import PageSkeleton from "./components/PageSkeleton";

import { createRoot } from 'react-dom/client'
import { StrictMode, Suspense } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import './i18n' // Import i18n configuration

// Create a root element for rendering
const container = document.getElementById("root")!
const root = createRoot(container)

// Create a loader component that shows while translations are loading
const Loader = () => <PageSkeleton />

// Render the app within React Strict Mode and with i18n Suspense
root.render(
  <StrictMode>
    <HelmetProvider>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    </HelmetProvider>
  </StrictMode>
);
